import React from "react";
import classnames from "classnames";
import Translate from "helpers/Translate";

function NoData({ showBorder = false }) {
  return (
    <div
      className={classnames("my-30 center", {
        "no-data": showBorder
      })}
    >
      {Translate({ id: "no_data_found" })}
    </div>
  );
}

export default NoData;
